import React, { Component } from "react";
import { Table, Button } from "semantic-ui-react";
import { find } from "lodash";
import SelectReport from "./SelectReport";
import {addReportIdToAdditionalData} from "../common/Utils";

class PersonRecordHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayMoreDetails: false,
      internalId: props.internalID,
      formData: props.formData,
      internalNameID: "1",
    };
  }

  componentWillReceiveProps(nextProps) {
    const internalId = nextProps.internalID;
    this.setState({
      displayMoreDetails: nextProps.selectedReportId === internalId,
      formData: nextProps.formData,
      internalId,
    });
  }

  onGetMoreDetailsClick = (e, optReportType, reportCost) => {
    let reportName;
    let reportApiName;
    if (optReportType === "persummary") {
      reportName = "Person/MoreDetails";
      reportApiName = "personReport";
    } else {
      reportApiName = "PersonReport";
    }
    this.setState({ displayMoreDetails: false });
    this.props.showReport(reportName, reportApiName, this.state.internalId, {
      internalNameID: this.state.internalNameID,
      bttype: this.props.userAccount.btType,
      optReportType:
        this.props.optReportType !== undefined &&
        this.props.optReportType !== ""
          ? this.props.optReportType
          : optReportType,
      requestedSection: this.props.requestedSection,
      ignoreReportId: true,
      reportCost,
      isGoldReport: this.props.isGoldSearch,
    });
  };

  onSelectReport = () => {
    this.setState({ displayMoreDetails: !this.state.displayMoreDetails });
    this.props.onSelectPersonReport(
      !this.state.displayMoreDetails ? this.state.internalId : null
    );
  };

  onBljReportClick = (internalID) => {
    const additionalData = {
          bttype: this.props.userAccount.btType,
          optReportType: "civil",
          internalID
        };
        addReportIdToAdditionalData(this.props, additionalData);
        this.props.showReport(
          undefined,
          "personBljReport",
          "",
          additionalData
        );
  }

  onNameSelect = (internalNameID) => {
    this.setState({ internalNameID });
  };

  render() {
    let headerClass = "result-header";
    const {searchResultData, formData, internalID} = this.props;
    const isBlj = Object.keys(searchResultData)[0].indexOf("blj") !== -1;
    if (
      formData.internalID !== undefined &&
      formData.internalID === internalID
    ) {
      headerClass = "result-ssn-header";
    }
    const {
      isSilverSearch,
      isGoldSearch,
      additionalData,
      uiData,
      userAccount,
    } = this.props;
    const perSummary = find(
      this.props.uiData.Reports,
      (d) => d.ReportOpt === "persummary"
    );
    let reportCost = "";
    let reportId = 0;
    if (
      isSilverSearch &&
      additionalData &&
      additionalData.reportIds &&
      additionalData.reportIds.length > 1
    ) {
      reportId = additionalData.reportIds[1];
      const rep = find(uiData.Reports, (r) => r.ReportID === reportId);
      if (rep) reportCost = rep.SearchResultCost;
      if (reportCost.toLowerCase() === "included") reportCost = "";
    }
    const compReportName = isSilverSearch ? "compsilver" : "comp";
    return (
      <Table>
        <Table.Body>
          <Table.Row className={headerClass}>
            <Table.Cell className={"icon-align-middle padding-10"}>
              {this.props.name}
            </Table.Cell>
            <Table.Cell className={"text-right padding-10"}>
              {isSilverSearch && (
                <div className="float-right-nomobile">
                  {perSummary !== undefined && (
                    <Button
                      primary
                      className={
                        userAccount.acctTheme === 0
                          ? "classic-submit margin-right-15"
                          : "margin-right-15"
                      }
                      onClick={(e) =>
                        this.onGetMoreDetailsClick(e, "persummary", reportCost)
                      }
                    >
                      Get More Details
                    </Button>
                  )}
                  <Button
                    primary
                    className={
                      userAccount.acctTheme === 0 ? "classic-submit" : ""
                    }
                    onClick={(e) =>
                      this.onGetMoreDetailsClick(
                        e,
                        isSilverSearch ? "compsilver" : "comp"
                      )
                    }
                  >
                    View Report
                    {`${reportCost !== "" ? ` - ${reportCost}` : ""}`}
                  </Button>
                </div>
              )}
              {!isSilverSearch &&
                (this.props.showDetailReport ? (
                  <div className="float-right-nomobile">
                    {perSummary !== undefined && (
                      <div>
                        <Button
                          // primary
                          className={
                            userAccount.acctTheme === 0
                              ? "classic-more-details"
                              : "more-details-button"
                          }
                          onClick={(e) =>
                            this.onGetMoreDetailsClick(e, "persummary")
                          }
                        >
                          We have more information on {this.props.name}. Click Here.
                        </Button>
                      </div>
                    )}
                  </div>
                ) : (
                  <Button
                    onClick={(e) =>
                      isBlj ? this.onBljReportClick(this.props.internalID) 
                      : this.onGetMoreDetailsClick(e, compReportName)
                    }
                  >
                    View Report
                  </Button>
                ))}
            </Table.Cell>
          </Table.Row>
          {this.state.displayMoreDetails === true ? (
            <Table.Row>
              <Table.Cell colSpan={2} className="padding-10">
                <SelectReport
                  name={this.props.name}
                  nameCollections={this.props.nameCollections}
                  internalId={this.state.internalId}
                  isGoldReport={isGoldSearch}
                  isSilverReport={false}
                  selectReportTitle={"Get Report For"}
                  {...this.props}
                  onNameSelect={this.onNameSelect}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
        </Table.Body>
      </Table>
    );
  }
}

export default PersonRecordHeader;



// WEBPACK FOOTER //
// ./src/components/searchresults/PersonRecordHeader.js